import {Component} from 'react';
import h from 'react-hyperscript';
import './SurveyHeader.scss';
import {h4, caption} from 'Components/Typography/Typography';
import ProgressBar from 'Components/DataViz/ProgressBar/ProgressBar';
import StickyElement from 'Components/StickyElement/StickyElement';

class SurveyHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formattedPercent: Math.round(this.props.totalPercentComplete * 100),
    };
  }

  componentDidMount() {
    this.setTotalPercentComplete();
  }

  componentDidUpdate(prevProps) {
    if (this.props.totalPercentComplete !== prevProps.totalPercentComplete) {
      this.setTotalPercentComplete();
    }
  }

  setTotalPercentComplete() {
    this.setState({
      formattedPercent: Math.round(this.props.totalPercentComplete * 100),
    });
  }
  renderHeaderContent() {
    return [h('div', {
      className: 'flex--space-between flex--wrap',
    }, [
      h(h4, {
        key: 'vision-card-title__key',
        className: 'survey__title',
      }, `${this.props.districtName}'s Transformation Feedback`),

      h('div', {
        key: 'vision-card-title-progress__key',
        className: 'survey__title-progress flex flex--wrap',
      }, [
        h(caption, {
          className: 'padding-right--sm',
        }, `${this.state.formattedPercent}% Complete`),

        h(ProgressBar, {
          key: 'survey-title__progress-bar',
          id: 'survey-title__progress-bar',
          value: this.props.totalPercentComplete,
          height: 8,
          width: 150,
          color: '#4285f4',
        }, null),
      ]),
    ])];
  }
  render() {
    return (
      [
        h('div', {
          className: 'inline-header',
          key: 'survey-header-inline',
        }, this.renderHeaderContent()
        ),
        h(StickyElement, {
          id: 'survey__header',
          offset: 188,
          key: 'survey-header-sticky',
        }, this.renderHeaderContent()),
      ]

    );
  }
}

export default SurveyHeader;
